module.exports = __webpack_public_path__ + "static/media/educationArticle2.005db5f7.jpg";